var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grade-transcript" },
    [
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "header-wrap" },
          [
            _c(
              "div",
              [
                _c(
                  "el-popover",
                  { attrs: { placement: "right-start", trigger: "click" } },
                  [
                    _c(
                      "ul",
                      {
                        staticClass: "class-list",
                        staticStyle: { "max-width": "90vw" },
                      },
                      _vm._l(_vm.classLists, function (item, index) {
                        return _c(
                          "li",
                          { key: index },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: item.selected ? "primary" : "info",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm._chosenClass(item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(item.gradeName) +
                                    _vm._s(item.className)
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          slot: "reference",
                          type: "primary",
                          size: "small",
                        },
                        slot: "reference",
                      },
                      [_vm._v("全部班级")]
                    ),
                  ],
                  1
                ),
                _c("search-bar", {
                  staticStyle: { "margin-left": "24px" },
                  attrs: { placeholder: "搜索(姓名)" },
                  on: {
                    search: function ($event) {
                      return _vm._searchStudentList()
                    },
                  },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm._searchStudentList()
                    },
                  },
                  model: {
                    value: _vm.keyword,
                    callback: function ($$v) {
                      _vm.keyword = $$v
                    },
                    expression: "keyword",
                  },
                }),
              ],
              1
            ),
            _vm.examInfo.isMore !== 2 && _vm.isExamSplit !== 1
              ? _c(
                  "el-button",
                  {
                    attrs: {
                      slot: "reference",
                      type: "primary",
                      size: "small",
                    },
                    on: { click: _vm.showExportPaper },
                    slot: "reference",
                  },
                  [_vm._v("导出原卷")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "card-content" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.studentLoading,
                    expression: "studentLoading",
                  },
                ],
                staticStyle: { width: "100%", "min-height": "220px" },
                attrs: {
                  data: _vm.studentList,
                  size: "medium",
                  "element-loading-text":
                    "年级学生较多，加载时间可能较长，请耐心等待",
                  "element-loading-spinner": "el-icon-loading",
                  "max-height": "600",
                  border: "",
                },
                on: { "sort-change": _vm.customSort },
              },
              [
                _c("el-table-column", {
                  attrs: { align: "center", label: "姓名" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.studentNameKeyword(
                                  scope.row.studentName,
                                  _vm.keyword
                                )
                              ),
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _vm.reportType == 1
                  ? _c("el-table-column", {
                      attrs: {
                        width: "150",
                        prop: "teachClassName",
                        align: "center",
                        sortable: "",
                        label: "班级(教学班)",
                      },
                    })
                  : _vm._e(),
                _c("el-table-column", {
                  attrs: {
                    width: "150",
                    align: "center",
                    prop: "className",
                    sortable: "",
                    label: _vm.reportType == 1 ? "班级(行政班)" : "班级",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    width: "120",
                    prop: "studentNo",
                    align: "center",
                    sortable: "",
                    label: "学号",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    width: "150",
                    prop: "score",
                    align: "center",
                    sortable: "",
                    label: "得分(客/主)",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.scoreFlag
                            ? _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      scope.row.type === 0 ? "(不参与)" : ""
                                    ) +
                                    " " +
                                    _vm._s(scope.row.score) +
                                    " " +
                                    _vm._s(scope.row.scoreFlag) +
                                    " "
                                ),
                              ])
                            : _c("span", [
                                _vm._v(
                                  _vm._s(
                                    scope.row.type === 0 ? "(不参与)" : ""
                                  ) +
                                    " " +
                                    _vm._s(
                                      scope.row.score < 0
                                        ? scope.row.score == -1
                                          ? "--"
                                          : "未上传"
                                        : scope.row.score
                                    )
                                ),
                              ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm.showRanking
                  ? [
                      _c("el-table-column", {
                        attrs: {
                          prop: "classRanking",
                          align: "center",
                          sortable: "",
                          label: "班次",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.classRanking < 0
                                          ? scope.row.classRanking == -1
                                            ? "--"
                                            : "未上传"
                                          : scope.row.classRanking
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2552928431
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "gradeRanking",
                          align: "center",
                          sortable: "",
                          label: "级次",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.gradeRanking < 0
                                          ? scope.row.gradeRanking == -1
                                            ? "--"
                                            : "未上传"
                                          : scope.row.gradeRanking
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1847313172
                        ),
                      }),
                    ]
                  : _vm._e(),
                _c("el-table-column", {
                  attrs: { align: "center", fixed: "right", label: "分析报告" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              staticClass: "link-btn",
                              attrs: { size: "mini", type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.locationTo(
                                    "/exam/single/report/class/transcript/",
                                    scope.row
                                  )
                                },
                              },
                            },
                            [_vm._v("查看")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              2
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.pageInfo.total,
                    expression: "pageInfo.total",
                  },
                ],
                staticClass: "pagination",
              },
              [
                _c("yue-pagination", {
                  attrs: { page: _vm.pageInfo },
                  on: { "current-change": _vm.handleCurrentChange },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("export-paper", {
        ref: "exportPaper",
        attrs: { examId: _vm.examId, examInfo: _vm.examInfo },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }